import { render, staticRenderFns } from "./SubmissionForm.vue?vue&type=template&id=4a24b6f0&scoped=true&"
import script from "./SubmissionForm.vue?vue&type=script&lang=ts&"
export * from "./SubmissionForm.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionForm.vue?vue&type=style&index=0&id=4a24b6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a24b6f0",
  null
  
)

export default component.exports